import { imprintPublishable } from '@/features/guest';
import { teamPrivacyPublishable } from './teamPrivacy';

/**
 * Impressum und Datenschutz klein unter der Anmeldung (PO 23.10.: „damit es rechtlich sauber ist“).
 * Die Texte kommen aus `docs/legal/` wie im Gastportal, und ein Link erscheint erst, wenn sein Text
 * keine Platzhalter mehr hat – ein unfertiges Impressum wäre schlimmer als keines. Der Datenschutz
 * ist ein eigener Text für das Team; der des Gastportals spricht Gäste an.
 */
const LINKS = [
  { to: '/legal/impressum', label: 'Impressum', ready: imprintPublishable },
  { to: '/legal/datenschutz', label: 'Datenschutz', ready: teamPrivacyPublishable },
];

export function AuthLegalFooter() {
  const links = LINKS.filter((link) => link.ready);
  if (links.length === 0) return null;
  return (
    <footer className="mx-auto mt-8 flex w-full max-w-[440px] flex-wrap gap-x-5">
      {links.map((link) => (
        <a
          key={link.to}
          href={link.to}
          target="_blank"
          rel="noopener"
          className="text-ink-soft hover:text-ink flex min-h-11 items-center font-mono text-[11px] uppercase tracking-[0.14em]"
        >
          {link.label}
        </a>
      ))}
    </footer>
  );
}
